<div class="line-chart--synced line-bar-chart" style="position: relative; display: block;">
  <canvas #chart1 baseChart
          [data]="lineChartData"
          [options]="options"
          [ngStyle]="{'height': chartHeight}"
          class="line-chart"
          id="chart1"
          [type]="'line'">
  </canvas>
  <canvas #hoverLineCanvas1 style="position: absolute; bottom: 0; left: 0; pointer-events: none;"></canvas>
</div>
<div class="line-bar-chart" style="position: relative; display: block;">
  <canvas #chart2 baseChart
          [data]="barChartData"
          [options]="optionsBar"
          [ngStyle]="{'height': chartHeight}"
          class="line-chart"
          id="chart2"
          [type]="'line'"
          [attr.aria-label]="ariaLabel">
  </canvas>
  <canvas #hoverLineCanvas2 style="position: absolute; bottom: 0; left: 0; pointer-events: none;"></canvas>
</div>
<div *ngIf="splitDateInRange" class="share-split-legend">
  <span class="share-split-dot"></span>
  <span>Indicates a share split occurred on this date.</span>
</div>